import ReactDOM from 'react-dom';

export const mountComponent = component => {
  const root = document.getElementById('modal-root');
  if (root) {
    ReactDOM.unmountComponentAtNode(root);
    ReactDOM.render(component, root);
  }
};

export const unmountCurrentComponent = () => {
  const root = document.getElementById('modal-root');
  ReactDOM.unmountComponentAtNode(root);
};



// WEBPACK FOOTER //
// ./src/utils/modals.js